import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import {
  De_signReferralLetterDocumentInput,
  useDeSignReferralDocumentMutation as useDeSignReferralDocumentMutationType,
} from "@/modules/patients/detail/referral/de/services/__generated__/useDeSignReferralDocumentMutation.graphql"

const approveDocumentMutation = graphql`
  mutation useDeSignReferralDocumentMutation($input: De_signReferralLetterDocumentInput!) {
    de_signReferralLetterDocument(input: $input) {
      de_ReferralLetter {
        id
        progressNoteId
        fileId
        signedAt
        signedBy
        updatedAt
        updatedBy
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeSignReferralDocumentMutationType>, "variables"> & {
  id: De_signReferralLetterDocumentInput["id"]
}

export const useDeSignReferralDocumentMutation = () => {
  const [commit, isLoading] = useMutation<useDeSignReferralDocumentMutationType>(approveDocumentMutation)

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isLoading] as const
}
